"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlob = getBlob;
exports.downloadBase64File = downloadBase64File;
function getBlob(base64Data) {
    var byteCharacters = atob(base64Data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var fileBlob = new Blob([byteArray], {
        type: "application/pdf", // "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });
    return fileBlob;
}
function downloadBase64File(base64Data, fileName) {
    var fileBlob = getBlob(base64Data);
    var a = document.createElement("a");
    a.href = URL.createObjectURL(fileBlob);
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
}
